<template>
    <b-container fluid>
        <page-title>
            <h2>
                <router-link :to="{ name: 'AgreementList' }" class="nav-link">Umowy</router-link>/Edycja/{{ retrieved && retrieved.customerData.name }}
            </h2>
            <div class="page-title__buttons">
                <router-link :to="{name: 'AgreementShow', params: { id: $route.params.id }}" title="Powrót"
                             class="btn btn-default"><span>Powrót</span>
                    <svg-icon name="back"/>
                </router-link>
            </div>
        </page-title>
        <div class="col page-element">
            <alert-loading v-if="loading"></alert-loading>
            <div v-if="retrieveError" class="alert alert-danger" role="alert"><span
                    class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ retrieveError }}
            </div>
            <div v-if="updateError" class="alert alert-danger" role="alert"><span
                    class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ updateError }}
            </div>

            <b-card v-show="!loading" no-body>
                <b-tabs v-model="tabIndex" ref="agreementTab" card :lazy="true">
                    <b-tab title="Dane podstawowe" active @click="goToTab('general')" >
                        <AgreementUpdateGeneral></AgreementUpdateGeneral>
                    </b-tab>
                    <b-tab title="Faktury" @click="goToTab('invoice')" >
                        <AgreementUpdateInvoice></AgreementUpdateInvoice>
                    </b-tab>
                    <b-tab title="Dokumenty" @click="goToTab('document')" :disabled="isTabDocumentDisabled">
                        <AgreementUpdateDocuments></AgreementUpdateDocuments>
                    </b-tab>
                    <b-tab title="Zaliczki, Potrącenia, Zwroty" @click="goToTab('additional')"  :disabled="isTabAdditionalDisabled">
                        <AgreementUpdateDeduction></AgreementUpdateDeduction>
                    </b-tab>
                    <b-tab title="Rozliczenie umowy" @click="showTab('settlement')" :disabled="isTabSettlementDisabled">
                        <AgreementUpdateSettlement></AgreementUpdateSettlement>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
    </b-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import AgreementUpdateGeneral from './UpdateGeneral.vue'
  import AgreementUpdateInvoice from './UpdateInvoice.vue'
  import AgreementUpdateDeduction from './UpdateDeduction.vue'
  import AgreementUpdateDocuments from './UpdateDocuments.vue'
  import AgreementUpdateSettlement from './UpdateSettlement.vue'

  export default {
    components: {
      AgreementUpdateGeneral,
      AgreementUpdateInvoice,
      AgreementUpdateDeduction,
      AgreementUpdateDocuments,
      AgreementUpdateSettlement
    },
    computed: {
      ...mapGetters({
        retrieveError: 'agreement/update/retrieveError',
        retrieveLoading: 'agreement/update/retrieveLoading',
        updateError: 'agreement/update/updateError',
        updateLoading: 'agreement/update/updateLoading',
        retrieved: 'agreement/update/retrieved',
        loadingCustomer: 'agreement/customer/loading',
      }),
      loading: function () {
        if (this.retrieveLoading || this.updateLoading || this.loadingCustomer) {
          return true
        }
        return false
      },
      isTabDocumentDisabled() {
        if (this.retrieved && this.retrieved.step.indexOf('document') > -1) {
          return false
        }
        return true
      },
      isTabAdditionalDisabled() {
        if (this.retrieved && this.retrieved.step.indexOf('additional') > -1) {
          return false
        }
        return true
      },
      isTabSettlementDisabled() {
        if (this.retrieved && this.retrieved.step.indexOf('settlement') > -1) {
          return false
        }
        return true
      }
    },
    data: function () {
      return {
        tabIndex: 0
      }
    },
    methods: {
      goToTab (tab) {
        this.$router.push({name: 'AgreementUpdate', params: {id: this.$route.params.id, tab: tab}})
      },
      showTab (tab) {
        if (tab == 'invoice') {
          this.tabIndex = 1
        } else if (tab == 'document') {
          this.tabIndex = 2
        } else if (tab == 'additional') {
          this.tabIndex = 3
        } else if (tab == 'settlement') {
          this.tabIndex = 4
        } else {
          this.tabIndex = 0
        }
        this.$refs.agreementTab.setTab(this.tabIndex)
      },
    },
    watch: {
      deleted: function (deleted) {
        if (deleted) {
          this.$router.push({name: 'AgreementList'})
        }
      }
    },
    created () {
      this.$store.dispatch('agreement/invoiceList/reset')
      this.$store.dispatch('agreement/update/retrieve', this.$route.params.id)
    },
    mounted () {
      this.showTab(this.$route.params.tab)
      this.$refs.agreementTab.setTab(this.tabIndex)
    },
    beforeDestroy () {
//      this.reset()
    }
  }
</script>



// WEBPACK FOOTER //
// Update.vue?4565065c